/**
 * Radio Advertising service page
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Radio, Mic, Volume2, CheckCircle } from 'lucide-react'

export default function RadioAdvertisingPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-purple-900 via-purple-800 to-violet-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Radio Advertising</h1>
              <p className="text-xl text-purple-100 leading-relaxed mb-8">
                Reach your audience through targeted radio campaigns with compelling audio content 
                that drives engagement and brand recall across prime listening times.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Launch Radio Campaign</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/e288a548-fe99-4c75-b31b-bc45ce6434ba.jpg" 
                alt="Radio Advertising"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Radio Campaign Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-purple-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Script Writing & Production</h3>
                    <p className="text-gray-600">Creative radio ads that capture attention and drive action</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-purple-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Voice Talent & Recording</h3>
                    <p className="text-gray-600">Professional voice actors and studio-quality production</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-purple-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Station Selection & Buying</h3>
                    <p className="text-gray-600">Optimal station and time slot selection for your audience</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/f0b2b0d9-b179-4bd8-91de-9023c9fe5396.png" 
                alt="Radio Studio"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-purple-900 to-violet-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Make Some Noise?</h2>
          <p className="text-xl text-purple-100 mb-8">
            Let us create compelling radio campaigns that reach your audience at the right time
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Start Radio Campaign</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
